"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TickCircle = function TickCircle() {
  return _react2.default.createElement(
    "g",
    { id: "tick-circle" },
    _react2.default.createElement("path", { d: "M221.6,380.5 L106.3,265.3 L160,211.6 L221.6,273.2 L348.4,146.4 L402.1,200.1 L221.6,380.5 Z M250,0 C112.1,0 0,112.1 0,250 C0,387.9 112.1,500 250,500 C387.9,500 500,387.9 500,250 C500,112.1 387.9,0 250,0 L250,0 Z" })
  );
};

exports.default = TickCircle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TickCircle.js
// module id = 2997
// module chunks = 4